export default __webpack_public_path__ + "static/media/JamBand.72130eed.jpg";